import { doGet, doPost } from "./common";

//TODO: Maybe we should store this in a cookie.

function getUsers(callback) {
  //console.log("### GetUsers##");
  doGet("/admin/users", {}, callback).then();
}

async function login(auth, callback, callback_error) {
  //console.log("### login##", auth);
  await doPost("/login", {}, auth, callback, false, 1, callback_error);
}

function register(auth, callback, callback_error) {
  //console.log("### register##", auth);
  doPost("/register", {}, auth, callback, false, 3, callback_error).then();
}

function changepassword(params, body, callback, callback_error) {
  //console.log("### changepassword##", params, body);
  doPost(
    "/register/password_change",
    params,
    body,
    callback,
    false,
    1,
    callback_error
  ).then();
}

export { changepassword, getUsers, login, register };
